import { Action, createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth.actions';
import { initialState, AuthState } from './auth.state';

const _authReducer = createReducer(
  initialState,
  on(
    AuthActions.saveEmail,
    (state, { email }): AuthState => ({
      ...state,
      email,
      error: null,
    })
  ),
  on(
    AuthActions.saveEmailResult,
    (state, { existing_user, company, email }): AuthState => ({
      ...state,
      existing_user,
      company,
      email,
      error: null,
    })
  ),
  on(
    AuthActions.forgotPasswordSuccess,
    (state, { success }): AuthState => ({
      ...state,
      forgotPasswordSuccess: success,
      error: null,
    })
  ),
  on(
    AuthActions.forgotPasswordFailure,
    (state, { error }): AuthState => ({
      ...state,
      forgotPasswordSuccess: false,
      error,
    })
  ),
  on(
    AuthActions.cleanForgotPassword,
    (state): AuthState => ({
      ...state,
      forgotPasswordSuccess: false,
    })
  ),
  on(
    AuthActions.setToken,
    (state, { token }): AuthState => ({
      ...state,
      token: token,
      error: null,
    })
  ),
  on(
    AuthActions.error,
    (state, { error }): AuthState => ({
      ...state,
      error,
    })
  ),
  on(
    AuthActions.setPendingPartnerSubscriptionOfferAfterSignUp,
    (state, { pending }): AuthState => ({
      ...state,
      pendingPartnerSubscriptionOfferAfterSignUp: pending,
    })
  )
);

export function authReducer(state: AuthState | undefined, action: Action) {
  return _authReducer(state, action);
}
